export enum MonitoringType {
  USA = 0,
  Ireland = 1
}
